import React from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import styled from "styled-components";
import { YukaThemeProvider } from "yuka";

import AxiosInstance from "./api/AxiosInstance";
import { API_ENDPOINTS } from "./api/constants";
import { AuthProvider } from "./auth";
import ErrorBoundary from "./ErrorBoundary";
import defaultTheme from "./hdYuka/defaultTheme";
import AgreementProvider from "./routes/AgreementProvider";
import MainRoutes from "./routes/component";
import StateProvider from "./routes/StateProvider";
import { installUnhandledRejectionLogger } from "./utils/installUnhandledRejectionLogger";
import { MixpanelProvider } from "./utils/mixpanel/MixpanelUtils";

const StyledHDContainer = styled.div`
  color: rgba(255, 255, 255, 0.8);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;

const MINUTE = 60 * 1000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 60 * MINUTE,
      staleTime: 60 * MINUTE,
    },
  },
});

// Install a global handler for unhandled promise rejections so that the cryptic
// "Uncaught (in promise) <minified-token>" errors observed in production
// (ZX-15035) leave a usable diagnostic trail in the console and on the server.
installUnhandledRejectionLogger({
  axios: AxiosInstance,
  reportUrl: API_ENDPOINTS.REPORT_ERROR(),
});

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <StateProvider>
            <AuthProvider>
              <MixpanelProvider>
                <YukaThemeProvider theme={defaultTheme}>
                  <AgreementProvider>
                    <StyledHDContainer>
                      <ErrorBoundary>
                        <MainRoutes />
                      </ErrorBoundary>
                    </StyledHDContainer>
                  </AgreementProvider>
                </YukaThemeProvider>
              </MixpanelProvider>
            </AuthProvider>
          </StateProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById("application")
  );
});
